import { useEffect, useState, useMemo } from "react";
import "@/App.css";

const WHATSAPP_NUMBER = "96895642297";
const PHONE_DISPLAY = "+968 9564 2297";
const EMAIL = "bbstationeryoman@gmail.com";

const LOGO =
  "https://customer-assets.emergentagent.com/job_ruwi-stationery-shop/artifacts/v1hdi763_WhatsApp%20Image%202026-04-25%20at%2011.14.16%20PM.jpeg";

const GALLERY = [
  "https://customer-assets.emergentagent.com/job_ruwi-stationery-shop/artifacts/lev87m76_WhatsApp%20Image%202026-04-25%20at%202.05.49%20PM%20%281%29.jpeg",
  "https://customer-assets.emergentagent.com/job_ruwi-stationery-shop/artifacts/6ivma938_WhatsApp%20Image%202026-04-25%20at%202.05.49%20PM.jpeg",
  "https://customer-assets.emergentagent.com/job_ruwi-stationery-shop/artifacts/tl9jrtjg_WhatsApp%20Image%202026-04-25%20at%202.05.56%20PM.jpeg",
  "https://customer-assets.emergentagent.com/job_ruwi-stationery-shop/artifacts/9vkqp9d7_WhatsApp%20Image%202026-04-25%20at%202.05.58%20PM.jpeg",
];

const SLIDES = [
  {
    image: GALLERY[2],
    eyebrow: "Welcome to Blue Line",
    title: "Your One-Stop Stationery & Office Supplies Shop in Ruwi",
    subtitle:
      "Pens, papers, files, cartridges, toners and everything in between — quality you can trust, prices you'll love.",
    cta: "Shop on WhatsApp",
  },
  {
    image: GALLERY[3],
    eyebrow: "Back to School & Office",
    title: "Bright Picks for Students, Artists & Professionals",
    subtitle:
      "Faber-Castell, Maxi, Pilot and more — colour pencils, art kits, markers and stickers in stock.",
    cta: "Order Now",
  },
  {
    image: GALLERY[0],
    eyebrow: "Bulk & Wholesale",
    title: "A4 Paper, Box Files & Office Essentials in Bulk",
    subtitle:
      "Double A, Paper One and trusted brands. Special pricing for offices, schools and businesses.",
    cta: "Get a Quote",
  },
];

const CATEGORIES = [
  { id: "stationery", label: "Stationery", icon: "fa-pen-fancy" },
  { id: "a4paper", label: "A4 Paper", icon: "fa-file-lines" },
  { id: "cartridges", label: "Cartridges", icon: "fa-print" },
  { id: "toners", label: "Toners", icon: "fa-fill-drip" },
];

const PRODUCTS = [
  // Stationery
  {
    id: 1,
    category: "stationery",
    name: "Faber-Castell Color Pencils (24 pcs)",
    price: "OMR 3.250",
    image:
      "https://images.unsplash.com/photo-1513364776144-60967b0f800f?auto=format&fit=crop&w=800&q=80",
    badge: "Bestseller",
  },
  {
    id: 2,
    category: "stationery",
    name: "Pilot Ballpoint Pens (Pack of 12)",
    price: "OMR 2.100",
    image:
      "https://images.unsplash.com/photo-1583485088034-697b5bc36b92?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 3,
    category: "stationery",
    name: "Maxi Highlighter Set (6 colors)",
    price: "OMR 1.800",
    image:
      "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 4,
    category: "stationery",
    name: "Box File A4 — Lever Arch",
    price: "OMR 1.200",
    image:
      "https://images.unsplash.com/photo-1568871391794-fbecc1d610ee?auto=format&fit=crop&w=800&q=80",
    badge: "Popular",
  },
  {
    id: 5,
    category: "stationery",
    name: "Sticky Notes Multi-Pack",
    price: "OMR 0.950",
    image:
      "https://images.unsplash.com/photo-1606857521015-7f9fcf423740?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 6,
    category: "stationery",
    name: "School Scissors & Glue Stick Set",
    price: "OMR 1.500",
    image:
      "https://images.unsplash.com/photo-1564845541707-aab3df57e8d4?auto=format&fit=crop&w=800&q=80",
  },

  // A4 Paper
  {
    id: 7,
    category: "a4paper",
    name: "Double A — A4 Copy Paper 80gsm (500 sheets)",
    price: "OMR 1.950",
    image:
      "https://images.unsplash.com/photo-1568667256549-094345857637?auto=format&fit=crop&w=800&q=80",
    badge: "Top Seller",
  },
  {
    id: 8,
    category: "a4paper",
    name: "Paper One — A4 Premium 80gsm (Box of 5)",
    price: "OMR 9.500",
    image:
      "https://images.unsplash.com/photo-1586281380349-632531db7ed4?auto=format&fit=crop&w=800&q=80",
    badge: "Bulk",
  },
  {
    id: 9,
    category: "a4paper",
    name: "Mondi Rotatrim — A4 70gsm",
    price: "OMR 1.700",
    image:
      "https://images.unsplash.com/photo-1455390582262-044cdead277a?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 10,
    category: "a4paper",
    name: "A3 Copy Paper 80gsm (500 sheets)",
    price: "OMR 3.800",
    image:
      "https://images.unsplash.com/photo-1606327054457-a72b27d6e0d4?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 11,
    category: "a4paper",
    name: "Coloured A4 Paper Assorted (100 sheets)",
    price: "OMR 1.200",
    image:
      "https://images.unsplash.com/photo-1502997104940-7f1c34a8c4c7?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 12,
    category: "a4paper",
    name: "A4 Glossy Photo Paper (50 sheets)",
    price: "OMR 2.400",
    image:
      "https://images.unsplash.com/photo-1574027542338-98e75acfd385?auto=format&fit=crop&w=800&q=80",
  },

  // Cartridges
  {
    id: 13,
    category: "cartridges",
    name: "HP 678 Black Ink Cartridge — Original",
    price: "OMR 6.500",
    image:
      "https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?auto=format&fit=crop&w=800&q=80",
    badge: "Original",
  },
  {
    id: 14,
    category: "cartridges",
    name: "HP 678 Tri-Colour Ink Cartridge",
    price: "OMR 7.200",
    image:
      "https://images.unsplash.com/photo-1606166187734-a4cb74079037?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 15,
    category: "cartridges",
    name: "Canon PG-47 Black Cartridge",
    price: "OMR 5.900",
    image:
      "https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 16,
    category: "cartridges",
    name: "Epson 664 Ink Bottle Set (4 colors)",
    price: "OMR 14.500",
    image:
      "https://images.unsplash.com/photo-1606166187734-a4cb74079037?auto=format&fit=crop&w=800&q=80",
    badge: "Set",
  },
  {
    id: 17,
    category: "cartridges",
    name: "Brother LC3617 Cartridge",
    price: "OMR 8.000",
    image:
      "https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 18,
    category: "cartridges",
    name: "Compatible HP 305 Combo Pack",
    price: "OMR 11.000",
    image:
      "https://images.unsplash.com/photo-1606166187734-a4cb74079037?auto=format&fit=crop&w=800&q=80",
  },

  // Toners
  {
    id: 19,
    category: "toners",
    name: "HP 12A Black Toner — LaserJet",
    price: "OMR 18.500",
    image:
      "https://images.unsplash.com/photo-1581090700227-1e37b190418e?auto=format&fit=crop&w=800&q=80",
    badge: "Original",
  },
  {
    id: 20,
    category: "toners",
    name: "HP 85A Black LaserJet Toner",
    price: "OMR 22.000",
    image:
      "https://images.unsplash.com/photo-1581090700227-1e37b190418e?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 21,
    category: "toners",
    name: "Canon 728 Black Toner Cartridge",
    price: "OMR 19.750",
    image:
      "https://images.unsplash.com/photo-1581090700227-1e37b190418e?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 22,
    category: "toners",
    name: "Samsung MLT-D101S Toner",
    price: "OMR 16.500",
    image:
      "https://images.unsplash.com/photo-1581090700227-1e37b190418e?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 23,
    category: "toners",
    name: "Brother TN-2380 Toner",
    price: "OMR 21.000",
    image:
      "https://images.unsplash.com/photo-1581090700227-1e37b190418e?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: 24,
    category: "toners",
    name: "Compatible HP CF217A Toner",
    price: "OMR 12.000",
    image:
      "https://images.unsplash.com/photo-1581090700227-1e37b190418e?auto=format&fit=crop&w=800&q=80",
    badge: "Value",
  },
];

const buildWaLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

const Header = ({ onNavClick }) => {
  const [open, setOpen] = useState(false);
  const handleClick = (id) => {
    setOpen(false);
    onNavClick(id);
  };
  return (
    <header className="bl-header" data-testid="site-header">
      <div className="bl-header-inner">
        <a
          className="bl-brand"
          href="#home"
          onClick={(e) => {
            e.preventDefault();
            handleClick("home");
          }}
          data-testid="brand-link"
        >
          <img src={LOGO} alt="Blue Line Trading & Business SPC" />
          <div className="bl-brand-text">
            <span className="bl-brand-title">Blue Line</span>
            <span className="bl-brand-sub">Trading &amp; Business SPC</span>
          </div>
        </a>

        <nav className={`bl-nav ${open ? "is-open" : ""}`}>
          {[
            ["home", "Home"],
            ["categories", "Categories"],
            ["products", "Products"],
            ["gallery", "Gallery"],
            ["contact", "Contact"],
          ].map(([id, label]) => (
            <a
              key={id}
              href={`#${id}`}
              onClick={(e) => {
                e.preventDefault();
                handleClick(id);
              }}
              data-testid={`nav-${id}`}
            >
              {label}
            </a>
          ))}
          <a
            className="bl-nav-cta"
            href={buildWaLink("Hello Blue Line, I'd like to place an order.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-btn"
          >
            <i className="fa-brands fa-whatsapp"></i> WhatsApp
          </a>
        </nav>

        <button
          className="bl-burger"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="menu-toggle"
        >
          <i className={`fa-solid ${open ? "fa-xmark" : "fa-bars"}`}></i>
        </button>
      </div>
    </header>
  );
};

const Hero = () => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % SLIDES.length), 5000);
    return () => clearInterval(t);
  }, []);
  const go = (i) => setIdx((i + SLIDES.length) % SLIDES.length);

  return (
    <section
      className="bl-hero"
      id="home"
      data-testid="hero-slider"
    >
      {SLIDES.map((s, i) => (
        <div
          key={i}
          className={`bl-slide ${i === idx ? "is-active" : ""}`}
          style={{ backgroundImage: `url(${s.image})` }}
          aria-hidden={i !== idx}
        >
          <div className="bl-slide-overlay" />
          <div className="bl-slide-content">
            <span className="bl-eyebrow">{s.eyebrow}</span>
            <h1 className="bl-hero-title">{s.title}</h1>
            <p className="bl-hero-sub">{s.subtitle}</p>
            <div className="bl-hero-actions">
              <a
                className="bl-btn bl-btn-primary"
                href={buildWaLink(
                  `Hi Blue Line, I'm interested in your products. ${s.title}`
                )}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`hero-cta-${i}`}
              >
                <i className="fa-brands fa-whatsapp"></i> {s.cta}
              </a>
              <a
                className="bl-btn bl-btn-ghost"
                href="#products"
                data-testid={`hero-browse-${i}`}
              >
                Browse Products <i className="fa-solid fa-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
      ))}

      <button
        className="bl-arrow bl-arrow-left"
        onClick={() => go(idx - 1)}
        aria-label="Previous slide"
        data-testid="hero-prev"
      >
        <i className="fa-solid fa-chevron-left"></i>
      </button>
      <button
        className="bl-arrow bl-arrow-right"
        onClick={() => go(idx + 1)}
        aria-label="Next slide"
        data-testid="hero-next"
      >
        <i className="fa-solid fa-chevron-right"></i>
      </button>

      <div className="bl-dots" data-testid="hero-dots">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            className={`bl-dot ${i === idx ? "is-active" : ""}`}
            onClick={() => go(i)}
            aria-label={`Go to slide ${i + 1}`}
            data-testid={`hero-dot-${i}`}
          />
        ))}
      </div>
    </section>
  );
};

const Marquee = () => (
  <div className="bl-marquee" aria-hidden="true">
    <div className="bl-marquee-track">
      {Array.from({ length: 2 }).map((_, k) => (
        <div className="bl-marquee-row" key={k}>
          <span><i className="fa-solid fa-truck-fast"></i> Same-day delivery in Muscat</span>
          <span><i className="fa-solid fa-tags"></i> Wholesale pricing for offices &amp; schools</span>
          <span><i className="fa-brands fa-whatsapp"></i> Order anytime on WhatsApp</span>
          <span><i className="fa-solid fa-shield-halved"></i> Original brands — HP, Canon, Pilot, Faber-Castell</span>
          <span><i className="fa-solid fa-location-dot"></i> Visit our store in Ruwi, Muscat</span>
        </div>
      ))}
    </div>
  </div>
);

const Categories = ({ active, setActive }) => (
  <section className="bl-section" id="categories" data-testid="categories-section">
    <div className="bl-container">
      <div className="bl-section-head">
        <span className="bl-eyebrow">Shop by Category</span>
        <h2 className="bl-h2">Everything your office or classroom needs</h2>
      </div>
      <div className="bl-cat-grid">
        {CATEGORIES.map((c) => (
          <button
            key={c.id}
            className={`bl-cat-card ${active === c.id ? "is-active" : ""}`}
            onClick={() => {
              setActive(c.id);
              const el = document.getElementById("products");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            data-testid={`category-${c.id}`}
          >
            <div className="bl-cat-icon">
              <i className={`fa-solid ${c.icon}`}></i>
            </div>
            <span className="bl-cat-label">{c.label}</span>
            <span className="bl-cat-count">
              {PRODUCTS.filter((p) => p.category === c.id).length} items
            </span>
            <span className="bl-cat-arrow">
              <i className="fa-solid fa-arrow-right"></i>
            </span>
          </button>
        ))}
      </div>
    </div>
  </section>
);

const ProductCard = ({ p }) => {
  const message = `Hi Blue Line, I'd like to buy:\n\n• ${p.name}\n• Price: ${p.price}\n\nIs this in stock?`;
  return (
    <article className="bl-card" data-testid={`product-card-${p.id}`}>
      <div className="bl-card-media">
        <img src={p.image} alt={p.name} loading="lazy" />
        {p.badge && <span className="bl-badge">{p.badge}</span>}
      </div>
      <div className="bl-card-body">
        <h3 className="bl-card-title">{p.name}</h3>
        <div className="bl-card-foot">
          <span className="bl-card-price">{p.price}</span>
          <a
            className="bl-buy"
            href={buildWaLink(message)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`buy-btn-${p.id}`}
          >
            <i className="fa-brands fa-whatsapp"></i> Buy
          </a>
        </div>
      </div>
    </article>
  );
};

const Products = ({ active, setActive }) => {
  const filtered = useMemo(
    () =>
      active === "all"
        ? PRODUCTS
        : PRODUCTS.filter((p) => p.category === active),
    [active]
  );

  return (
    <section className="bl-section bl-section-tint" id="products" data-testid="products-section">
      <div className="bl-container">
        <div className="bl-section-head">
          <span className="bl-eyebrow">Our Products</span>
          <h2 className="bl-h2">Handpicked essentials, ready to ship</h2>
        </div>

        <div className="bl-tabs" data-testid="product-tabs">
          <button
            className={`bl-tab ${active === "all" ? "is-active" : ""}`}
            onClick={() => setActive("all")}
            data-testid="tab-all"
          >
            All
          </button>
          {CATEGORIES.map((c) => (
            <button
              key={c.id}
              className={`bl-tab ${active === c.id ? "is-active" : ""}`}
              onClick={() => setActive(c.id)}
              data-testid={`tab-${c.id}`}
            >
              {c.label}
            </button>
          ))}
        </div>

        <div className="bl-grid" data-testid="product-grid">
          {filtered.map((p) => (
            <ProductCard key={p.id} p={p} />
          ))}
        </div>
      </div>
    </section>
  );
};

const Gallery = () => (
  <section className="bl-section" id="gallery" data-testid="gallery-section">
    <div className="bl-container">
      <div className="bl-section-head">
        <span className="bl-eyebrow">Inside the store</span>
        <h2 className="bl-h2">Visit us in Ruwi — bright, well-stocked aisles</h2>
      </div>
      <div className="bl-gallery">
        {GALLERY.map((src, i) => (
          <a
            key={i}
            className={`bl-gallery-item bl-gallery-item-${i}`}
            href={src}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`gallery-img-${i}`}
          >
            <img src={src} alt={`Blue Line store photo ${i + 1}`} loading="lazy" />
          </a>
        ))}
      </div>
    </div>
  </section>
);

const About = () => (
  <section className="bl-section bl-about" data-testid="about-section">
    <div className="bl-container bl-about-grid">
      <div className="bl-about-copy">
        <span className="bl-eyebrow">About Blue Line</span>
        <h2 className="bl-h2">Trusted stationery partner in the Sultanate of Oman</h2>
        <p>
          Blue Line Trading &amp; Business SPC is a Ruwi-based supplier of stationery,
          office supplies and computer equipment. From a single pen to a full
          office fit-out, we serve students, businesses, schools and government
          offices across Muscat and beyond.
        </p>
        <ul className="bl-about-list">
          <li><i className="fa-solid fa-circle-check"></i> Original &amp; compatible inks &amp; toners</li>
          <li><i className="fa-solid fa-circle-check"></i> Fast WhatsApp ordering &amp; delivery</li>
          <li><i className="fa-solid fa-circle-check"></i> Wholesale &amp; corporate quotations</li>
          <li><i className="fa-solid fa-circle-check"></i> Trusted brands: HP, Canon, Pilot, Faber-Castell, Maxi</li>
        </ul>
        <a
          className="bl-btn bl-btn-primary"
          href={buildWaLink("Hi Blue Line, I'd like a corporate quotation.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="about-cta"
        >
          <i className="fa-brands fa-whatsapp"></i> Request a Quote
        </a>
      </div>
      <div className="bl-about-stats">
        <div className="bl-stat"><span>10+</span><p>Years serving Oman</p></div>
        <div className="bl-stat"><span>1000+</span><p>Products in stock</p></div>
        <div className="bl-stat"><span>500+</span><p>Happy customers</p></div>
        <div className="bl-stat"><span>24/7</span><p>WhatsApp support</p></div>
      </div>
    </div>
  </section>
);

const Contact = () => (
  <section className="bl-section bl-section-dark" id="contact" data-testid="contact-section">
    <div className="bl-container bl-contact-grid">
      <div>
        <span className="bl-eyebrow bl-eyebrow-light">Get in touch</span>
        <h2 className="bl-h2 bl-h2-light">
          Ready to order? We're a message away.
        </h2>
        <p className="bl-contact-lead">
          Send us your list on WhatsApp, drop by the shop, or email us — we
          reply quickly and ship across Oman.
        </p>
        <a
          className="bl-btn bl-btn-primary bl-btn-lg"
          href={buildWaLink("Hello Blue Line, I'd like to place an order.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-whatsapp-btn"
        >
          <i className="fa-brands fa-whatsapp"></i> Chat on WhatsApp
        </a>
      </div>

      <div className="bl-contact-cards">
        <div className="bl-contact-card">
          <i className="fa-solid fa-phone"></i>
          <div>
            <span>Call us</span>
            <a href={`tel:+${WHATSAPP_NUMBER}`} data-testid="contact-phone">{PHONE_DISPLAY}</a>
          </div>
        </div>
        <div className="bl-contact-card">
          <i className="fa-solid fa-envelope"></i>
          <div>
            <span>Email</span>
            <a href={`mailto:${EMAIL}`} data-testid="contact-email">{EMAIL}</a>
          </div>
        </div>
        <div className="bl-contact-card">
          <i className="fa-solid fa-location-dot"></i>
          <div>
            <span>Visit</span>
            <p>P.O. Box: 3699, Postal Code: 112<br/>Ruwi — Sultanate of Oman</p>
          </div>
        </div>
        <div className="bl-contact-card">
          <i className="fa-solid fa-clock"></i>
          <div>
            <span>Hours</span>
            <p>Sat – Thu, 9:00 AM – 9:00 PM<br/>Friday: 4:00 PM – 9:00 PM</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

const Footer = () => (
  <footer className="bl-footer" data-testid="site-footer">
    <div className="bl-container bl-footer-grid">
      <div>
        <img src={LOGO} alt="Blue Line" className="bl-footer-logo" />
        <p>
          Stationery, office supplies and computer equipment — proudly serving
          Ruwi and the Sultanate of Oman.
        </p>
      </div>
      <div>
        <h4>Categories</h4>
        <ul>
          {CATEGORIES.map((c) => (
            <li key={c.id}>
              <a href="#products">{c.label}</a>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <h4>Contact</h4>
        <ul>
          <li><a href={`tel:+${WHATSAPP_NUMBER}`}>{PHONE_DISPLAY}</a></li>
          <li><a href={`mailto:${EMAIL}`}>{EMAIL}</a></li>
          <li>Ruwi, Sultanate of Oman</li>
        </ul>
      </div>
    </div>
    <div className="bl-footer-bottom">
      <p>© {new Date().getFullYear()} Blue Line Trading &amp; Business SPC. All rights reserved.</p>
    </div>
  </footer>
);

const FloatingWhatsApp = () => (
  <a
    className="bl-fab"
    href={buildWaLink("Hi Blue Line, I have a question.")}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    data-testid="fab-whatsapp"
  >
    <i className="fa-brands fa-whatsapp"></i>
  </a>
);

function App() {
  const [active, setActive] = useState("all");

  const handleNav = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    document.title =
      "Blue Line Trading & Business SPC | Stationery Shop in Ruwi, Oman";
  }, []);

  return (
    <div className="bl-root">
      <Header onNavClick={handleNav} />
      <Hero />
      <Marquee />
      <Categories active={active} setActive={setActive} />
      <Products active={active} setActive={setActive} />
      <Gallery />
      <About />
      <Contact />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
